// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".draft-message-table-component .overflow-hidden[data-v-123d2fa6]{overflow:hidden!important;text-overflow:ellipsis;white-space:nowrap}.draft-message-table-component .delete-btn[data-v-123d2fa6],.draft-message-table-component .edit-btn[data-v-123d2fa6]{width:64px}.draft-message-table-component .edit-btn[data-v-123d2fa6]{margin-right:5px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
